module.exports = __webpack_public_path__ + "static/media/coffee-machine.92adc59f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coffee-machine.jpg
// module id = 89
// module chunks = 3